

// ==============================|| MAIN CARD ||============================== //

export default function Breadcrumb(props) {
    const { pageTitle, secondTitle } = props;
    return (
        <div className="page-header">
            <div className="page-block">
                <div className="align-items-center row">
                    <div className="page-header-title text-capitalize col-md-12">
                        <h5>{pageTitle}</h5>
                    </div>
                    <div className="col-md-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb" style={{ marginBottom: 0 }}>
                                <li className="breadcrumb-item">
                                    <a href="/cpnl/dashboard">Home</a>
                                </li>
                                {secondTitle && <li className="breadcrumb-item text-capitalize">
                                    <a href="#" role="button" tabIndex={0}>
                                        {secondTitle}
                                    </a>
                                </li>}
                                <li className="breadcrumb-item text-capitalize">
                                    <a href="#" role="button" tabIndex={0}>
                                        {pageTitle}
                                    </a>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    );
}
